import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { CircularProgress } from './CircularProgress';
export interface LoaderProps {
  invisible?: boolean;
  noFlex?: boolean;
  noMargin?: boolean;
  loaderColor?: string;
  loaderSize?: number | string;
}

const useStyle = makeStyles<Theme, LoaderProps>(() =>
  createStyles({
    loader: {
      display: ({ noFlex }) => (noFlex ? 'inherit' : 'flex'),
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      marginTop: ({ noMargin }) => (noMargin ? 0 : 16),
      visibility: ({ invisible }) => (invisible ? 'hidden' : 'visible'),
      overflow: 'hidden',
      '& svg': {
        color: ({ loaderColor }) => (loaderColor ? `${loaderColor}` : undefined),
      },
    },
  }),
);

export const Loader: React.FC<LoaderProps> = (props) => {
  const style = useStyle(props);
  return (
    <div className={style.loader} aria-hidden={props.invisible}>
      <CircularProgress size={props.loaderSize} aria-hidden={props.invisible} />
    </div>
  );
};
